<div class="container" appSwipeScroll>
<p-carousel class="draggable" *ngIf="viewport.isMobile" [value]="steps" [numScroll]="1" [numVisible]="1" [showIndicators]="true" [showNavigators]="false">
    <ng-template let-step pTemplate="item">
        <div class="steps">
            <img [src]="step.image" [alt]="step.title" />
            <div class="deal-info">
                <h3>{{ step.title }}</h3>
                <p class="discount">{{ step.description }}</p>
            </div>
        </div>
    </ng-template>
</p-carousel>
</div>
